<script setup>
import {onMounted, ref, computed} from 'vue'
import { useUserStore } from '@/stores/user'

const userStore = useUserStore()

function getUsagePercentage(used, limit) {
  if (!limit || limit === 0) return 0
  const percentage = (used / limit) * 100
  return Math.min(percentage, 100)
}

const dailyPercentage = computed(() => {
  return getUsagePercentage(userStore.api_daily_spend, userStore.limit_api_daily)
})

const monthlyPercentage = computed(() => {
  return getUsagePercentage(userStore.api_monthly_spend, userStore.limit_api_monthly)
})

onMounted(async () => {
  await userStore.details()
})

</script>

<template>
  <div class="usage-container">
    <div class="stat-card">
      <div class="stat-label">Daily Usage</div>
      <div class="stat-value">
        {{ userStore.api_daily_spend || 0 }} <span class="stat-limit">/ {{ userStore.limit_api_daily || 0 }}</span>
      </div>
      <div class="stat-progress">
        <div
          class="stat-progress-bar"
          :style="{ width: dailyPercentage + '%' }"
        ></div>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-label">Monthly Usage</div>
      <div class="stat-value">
        {{ userStore.api_monthly_spend || 0 }} <span class="stat-limit">/ {{ userStore.limit_api_monthly || 0 }}</span>
      </div>
      <div class="stat-progress">
        <div
          class="stat-progress-bar"
          :style="{ width: monthlyPercentage + '%' }"
        ></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.usage-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.stat-card {
  background: rgba(26, 29, 36, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 0.5rem;
  padding: 1rem;
}

.stat-label {
  font-size: 0.75rem;
  color: #9CA3AF;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.stat-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: #f3f4f6;
  margin-bottom: 0.75rem;
}

.stat-limit {
  font-size: 0.875rem;
  color: #6B7280;
  font-weight: 400;
}

.stat-progress {
  height: 4px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 2px;
  overflow: hidden;
}

.stat-progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #a855f7 0%, #7357D2 100%);
  transition: width 0.3s ease;
}

/* Responsive Design */
@media (max-width: 768px) {
  .usage-container {
    grid-template-columns: 1fr;
  }
}
</style>
